<!--
Notification component
Usage: <NotifItem title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
  <div :id="'nibg' + paramKey" class="notifDive">

    <img src="@/assets/notif_bg.svg" class="notifBg" />
    <span>
      <font-awesome-icon v-if="icon" :icon="icon" :id="'notifIcon' + paramKey" size="1x" class="notificationIcon"></font-awesome-icon>
      <h5 class="notifHeader">{{ title }}</h5>

    </span><br>

    <p class="notifBody">{{ parseLinks(body) }}</p>
    <div v-if="link" @click="notifGo(link)">
        <font-awesome-icon icon="arrow-right" size="sm" class="notifItemChev"></font-awesome-icon>
    </div>
    <span class="notifTime">{{ getTime(time) }}</span>

  </div>
</template>

<script>

export default {
  name: 'NotifItem',
  props: ['title', 'body', 'time', 'paramKey','icon', 'link', 'unread'],
  data () {
    return {
    }
  },
  mounted () {
    
    const bgHalfWidth = 28 // 36px wide with 10px margins
    const bgHalfHeight = 28 // 36 px tall with 10px margins

    var img = document.getElementById('notifIcon' + this.paramKey)
    if (typeof img !== 'undefined' && img != null) {
      const imgWidth = img.getBoundingClientRect().width
      const imgHeight = img.getBoundingClientRect().height

      var marginLeft = bgHalfWidth - (imgWidth / 2)
      var marginTop = bgHalfHeight - (imgHeight / 2)

      img.style.left = marginLeft
      img.style.top = marginTop
    }
    if (this.paramKey < this.unread) {
      document.getElementById('nibg' + this.paramKey).setAttribute('style', 'background-color:rgba(0, 56, 101, 0.1);')
    }
  },
  methods: {
    notifGo (url) {
      if (url.includes('http')) {
        window.open(url)
      } else {
        this.$router.push(url)
      }
    },
    parseLinks (text) {
      let linkMatch = text.match(/(https:\/\/\S+)/)
      if (linkMatch) {
        text = text.replace(linkMatch[0], '')
      }
      return text
    },
    getTime (time) {
      let minute = 60000
      let hour = minute * 60
      let day = hour * 24
      let week = day * 7
      let year = day * 365
      var now = new Date()
      now = Date.now()
      let diff = now - time

      if (diff < minute) {
        return 'now'
      }
      if (diff < hour) {
        return Math.round(diff / minute) + 'm ago'
      }
      if (diff < day) {
        return Math.round(diff / hour) + 'h ago'
      }
      if (diff < week) {
        return Math.round(diff / day) + 'd ago'
      }
      if (diff < year) {
        return Math.round(diff / week) + 'w ago'
      }
      return Math.round(diff / year) + 'y ago'
    }
  }
}
</script>
<style>

.notifTime {
  font-size:12px;
  color:#005C8A;
  font-weight:900;
  padding-bottom:8px;
  margin-left:48px;
}
.notifItemChev {
  position:absolute;
  color:#003865;
  top:50%;
  right:5%;
}

.notificationIcon {
  z-index:999;
  position:absolute;
  color:#ffffff;
}

.notifDive {
  margin-bottom:12px;
  padding:16px;
  padding-bottom:0px;
  padding-top:8px;
  position:relative;
  border: 1px solid #E4E4E4;
  box-sizing: border-box;
  border-radius: 24px;
  padding-bottom:8px;
}

.notifBg {
  position:absolute;
  left:10px;
  top:10px;
  z-index:-1;
}

.notifBody {
  font-size: 16px;
  color: #4F5961;
  padding-left:48px;
  padding-right:8%;
  margin-bottom:8px;
  display:inline-block;
}

.notifHeader {
  font-style: normal;
  display:inline-block;
  padding-left:48px;
  font-weight: bold;
  font-size: 16px;
  line-height:21px;
  color: #0A3875;
}
</style>
